var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M200,80 C160,80 130,110 130,150 C130,175 145,195 165,205 L165,230 C165,240 175,250 185,250 L215,250 C225,250 235,240 235,230 L235,205 C255,195 270,175 270,150 C270,110 240,80 200,80Z",
    fill: "#1e3a8a",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,80 C160,80 130,110 130,150 C130,175 145,195 165,205 L165,230 C165,240 175,250 185,250 L215,250 C225,250 235,240 235,230 L235,205 C255,195 270,175 270,150 C270,110 240,80 200,80Z",
    fill: "none",
    stroke: "#093f68",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 130,
    r: 8,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 130,
    r: 8,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 110,
    r: 8,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 160,
    r: 8,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 160,
    r: 8,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 185,
    r: 8,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 130,
    x2: 200,
    y2: 110,
    stroke: "#093f68",
    strokeWidth: 2,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230,
    y1: 130,
    x2: 200,
    y2: 110,
    stroke: "#093f68",
    strokeWidth: 2,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 130,
    x2: 185,
    y2: 160,
    stroke: "#093f68",
    strokeWidth: 2,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230,
    y1: 130,
    x2: 215,
    y2: 160,
    stroke: "#093f68",
    strokeWidth: 2,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 130,
    x2: 215,
    y2: 160,
    stroke: "#093f68",
    strokeWidth: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230,
    y1: 130,
    x2: 185,
    y2: 160,
    stroke: "#093f68",
    strokeWidth: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 160,
    x2: 200,
    y2: 185,
    stroke: "#093f68",
    strokeWidth: 2,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215,
    y1: 160,
    x2: 200,
    y2: 185,
    stroke: "#093f68",
    strokeWidth: 2,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 110,
    x2: 185,
    y2: 160,
    stroke: "#093f68",
    strokeWidth: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 110,
    x2: 215,
    y2: 160,
    stroke: "#093f68",
    strokeWidth: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 105,
    r: 4,
    fill: "#ffbc0e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245,
    cy: 105,
    r: 4,
    fill: "#ffbc0e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 170,
    r: 4,
    fill: "#f56132"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 170,
    r: 4,
    fill: "#f56132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,95 C135,105 135,115 145,125",
    fill: "none",
    stroke: "#ffbc0e",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,95 C265,105 265,115 255,125",
    fill: "none",
    stroke: "#ffbc0e",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 245,
    width: 40,
    height: 10,
    rx: 3,
    fill: "#725858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,245 L180,255 L220,255 L220,245Z",
    fill: "none",
    stroke: "#093f68",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 255,
    x2: 190,
    y2: 270,
    stroke: "#093f68",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 255,
    x2: 200,
    y2: 275,
    stroke: "#093f68",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 255,
    x2: 210,
    y2: 270,
    stroke: "#093f68",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 270,
    r: 3,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 275,
    r: 3,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 270,
    r: 3,
    fill: "#1e3a8a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.530b03d11f0e5984ca00bbbd1c4f00d9.svg";
export { ForwardRef as ReactComponent };